import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { useGetFirefliesStatus } from "../../api/generated/generated";
import { ConnectFirefliesModal } from "../integrations/ConnectFirefliesModal";
import { DisconnectConfirmDialog } from "../integrations/DisconnectConfirmDialog";

export function ConnectedAccountsSection() {
  const { data: statusResp, isLoading } = useGetFirefliesStatus();
  const status = statusResp?.data;
  const [connectOpen, setConnectOpen] = useState(false);
  const [disconnectOpen, setDisconnectOpen] = useState(false);

  if (isLoading) {
    return (
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Connected Accounts
        </Typography>
        <Skeleton variant="rounded" height={60} />
      </Paper>
    );
  }

  const isConnected = status?.status === "connected";
  const isError = status?.status === "error";

  return (
    <>
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Connected Accounts
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            border: 1,
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          <Stack direction="row" spacing={2} sx={{
            alignItems: "center"
          }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1,
                bgcolor: "secondary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: 700,
                fontSize: "0.875rem",
              }}
            >
              FF
            </Box>
            <Box>
              <Typography variant="subtitle2">Fireflies.ai</Typography>
              {isConnected && status?.connected_at && (
                <Typography variant="caption" sx={{
                  color: "text.secondary"
                }}>
                  Connected {new Date(status.connected_at).toLocaleDateString()}
                </Typography>
              )}
              {isError && (
                <Typography variant="caption" color="error">
                  {status?.error_message || "Connection error"}
                </Typography>
              )}
            </Box>
          </Stack>

          <Stack direction="row" spacing={1} sx={{
            alignItems: "center"
          }}>
            {isConnected && (
              <Chip
                label="Connected"
                color="success"
                size="small"
                variant="outlined"
              />
            )}
            {isError && (
              <Chip
                label="Error"
                color="error"
                size="small"
                variant="outlined"
              />
            )}
            {!isConnected && !isError && (
              <Chip
                label="Not Connected"
                color="default"
                size="small"
                variant="outlined"
              />
            )}

            {isConnected || isError ? (
              <Button
                size="small"
                color="error"
                startIcon={<LinkOffIcon />}
                onClick={() => setDisconnectOpen(true)}
              >
                Disconnect
              </Button>
            ) : (
              <Button
                size="small"
                variant="contained"
                onClick={() => setConnectOpen(true)}
              >
                Connect
              </Button>
            )}
          </Stack>
        </Box>
      </Paper>
      <ConnectFirefliesModal
        open={connectOpen}
        onClose={() => setConnectOpen(false)}
        onSuccess={() => setConnectOpen(false)}
      />
      <DisconnectConfirmDialog
        open={disconnectOpen}
        onClose={() => setDisconnectOpen(false)}
        onSuccess={() => setDisconnectOpen(false)}
      />
    </>
  );
}
